import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c1847d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "description-subtitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputMarket" }, " Market ", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "accountInterestReceived" }, " Account Interest Received ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "null",
  disabled: "",
  selected: "",
  hidden: ""
}, "mandatory", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "accountInterestAccumulated" }, " Account Interest Accumulated ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "null",
  disabled: "",
  selected: "",
  hidden: ""
}, "mandatory", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "amount" }, " Amount ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "interestPeriod" }, " Interest Period ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "interestDateReceived" }, " Interest Date Received ", -1))
const _hoisted_15 = ["disabled"]

import '@vuepic/vue-datepicker/dist/main.css';
import {ref,computed} from 'vue';
import Popup from '../Popup.vue';
import PeriodSelector from '../PeriodSelector.vue';
import useSpinnerPopup from '@/services/composables/SpinnerPopup';
import IInterestPaymentRequest from '@/Interfaces/Ledgering/IInterestPaymentRequest';
import { confirmInterestPayment } from '@/services/network';
import { MarketCurrency, marketSelection } from '@/services/helpers/Helper';
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';
import { authService } from "@/auth/authSingleton";
import CurrencyInput from "@/components/CurrencyInput.vue";

enum AccountInterestReceived {
    COLLECTION = 'COLLECTION',
    CORPORATE = 'CORPORATE',
    RESERVE = 'RESERVE'
}
enum AccountInterestAccumulated {
    COLLECTION = 'COLLECTION',
    CORPORATE = 'CORPORATE',
    RESERVE = 'RESERVE'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmInterestPaymentPopUp',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const displayingForm = computed({
    get(){
        interestPaymentToConfirm.value.market = marketSelection.value;
        interestPaymentToConfirm.value.userStatusUpdated = authService.getEmailAddress();
        return props.modelValue;
    },
    set(val: boolean) {
        emits('update:modelValue', val);
    }
});
const working = ref(false);
const interestPaymentToConfirm = ref<Partial<IInterestPaymentRequest>>({});
const receivedAccountTypes : string[] = Object.values(AccountInterestReceived)
const accumulatedAccountTypes : string[] = Object.values(AccountInterestAccumulated)

function closeChild() {
    interestPaymentToConfirm.value = { market: marketSelection.value } as Partial<IInterestPaymentRequest>;
    displayingForm.value = false;
}
function validateRequest(obj: Partial<IInterestPaymentRequest>): obj is IInterestPaymentRequest {
    let validationResult = true;
    const date = obj.interestDateReceived;
    const period = obj.interestPeriod;
    if( !!date && !!period) {
        if (Date.parse(date.toString()) < Date.parse(period.toString())) {
            validationResult = false;
            useNotifierWithErrFormatter().warn({
                msg: "Interest Date Received must not be earlier than Interest Period"
            })
        }
    }
    else {validationResult = false}
    return validationResult;
}
async function confirmPayment() {
    if (working.value) return;
    working.value = true;
    const closeSpinner = useSpinnerPopup().show();
    try {
        if (!validateRequest(interestPaymentToConfirm.value)) return;
        const interestPaymentRequest: IInterestPaymentRequest = interestPaymentToConfirm.value;
        const res = await confirmInterestPayment.post(interestPaymentRequest);
        useNotifierWithErrFormatter().success({msg: 'Transaction successfully registered.'});
        closeChild();
        emits('confirm');
    } catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: 'Submitting Interest Payment',
            error
        });
    } finally {
        closeSpinner();
        working.value=false
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: displayingForm.value,
    "onUpdate:modelValue": closeChild,
    title: "Record Received Interest",
    hasClose: ""
  }, {
    contents: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "two-column",
          onSubmit: _withModifiers(confirmPayment, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("input", {
              id: "inputMarket",
              ref: "inputMarket",
              class: "col2",
              type: "text",
              title: "'Market' is selected from the drop down on the main table",
              value: interestPaymentToConfirm.value.market,
              disabled: "",
              required: ""
            }, null, 8, _hoisted_5),
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              id: "accountInterestReceived",
              ref: "accountInterestReceived",
              class: "col2",
              title: "Select Account Interest Received",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((interestPaymentToConfirm.value.receivedAccountType) = $event)),
              required: ""
            }, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(receivedAccountTypes), (accountType) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: accountType,
                  key: accountType
                }, _toDisplayString(accountType), 9, _hoisted_8))
              }), 128))
            ], 512), [
              [_vModelSelect, interestPaymentToConfirm.value.receivedAccountType]
            ]),
            _hoisted_9,
            _withDirectives(_createElementVNode("select", {
              id: "accountInterestAccumulated",
              ref: "accountInterestAccumulated",
              class: "col2",
              title: "Select Account Interest Accumulated",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((interestPaymentToConfirm.value.accumulatedAccountType) = $event)),
              required: ""
            }, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accumulatedAccountTypes), (accountType) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: accountType,
                  key: accountType
                }, _toDisplayString(accountType), 9, _hoisted_11))
              }), 128))
            ], 512), [
              [_vModelSelect, interestPaymentToConfirm.value.accumulatedAccountType]
            ]),
            _hoisted_12,
            _createVNode(CurrencyInput, {
              id: "amount",
              ref: "amount",
              modelValue: interestPaymentToConfirm.value.amount,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((interestPaymentToConfirm.value.amount) = $event)),
              class: "col2 invalid-input",
              currency: _unref(MarketCurrency)[_unref(marketSelection)],
              title: "Input interest payment amount.",
              min: 0.01,
              placeholder: 'Amount',
              required: ""
            }, null, 8, ["modelValue", "currency"]),
            _hoisted_13,
            _createVNode(PeriodSelector, {
              id: "interestPeriod",
              class: "col2",
              type: "text",
              title: "Select interest period",
              modelValue: interestPaymentToConfirm.value.interestPeriod,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((interestPaymentToConfirm.value.interestPeriod) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              id: "interestDateReceived",
              ref: "interestDateReceived",
              class: "col2",
              type: "date",
              title: "Select interest date received",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((interestPaymentToConfirm.value.interestDateReceived) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, interestPaymentToConfirm.value.interestDateReceived]
            ])
          ]),
          _createElementVNode("button", {
            disabled: working.value,
            class: "confirm-button",
            type: "submit"
          }, " Confirm ", 8, _hoisted_15)
        ], 40, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})